import { SelectItem } from "primeng/api";

export const ruleStateOptions: SelectItem[] = [
    { label: 'Tous', value: 'all' },
    { label: 'En erreur', value: 'error' },
    { label: 'En santé', value: 'healthy' },
    { label: 'En retard', value: 'stale' },
  ];